"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIRAI_API_HTTP_VERSION = exports.ResponseCode = exports.FaceType = void 0;
/** 表情类型映射 */
var FaceType;
(function (FaceType) {
    FaceType[FaceType["JING_YA"] = 0] = "JING_YA";
    FaceType[FaceType["\u60CA\u8BB6"] = 0] = "\u60CA\u8BB6";
    FaceType[FaceType["PIE_ZUI"] = 1] = "PIE_ZUI";
    FaceType[FaceType["\u6487\u5634"] = 1] = "\u6487\u5634";
    FaceType[FaceType["SE"] = 2] = "SE";
    FaceType[FaceType["\u8272"] = 2] = "\u8272";
    FaceType[FaceType["FA_DAI"] = 3] = "FA_DAI";
    FaceType[FaceType["\u53D1\u5446"] = 3] = "\u53D1\u5446";
    FaceType[FaceType["DE_YI"] = 4] = "DE_YI";
    FaceType[FaceType["\u5F97\u610F"] = 4] = "\u5F97\u610F";
    FaceType[FaceType["LIU_LEI"] = 5] = "LIU_LEI";
    FaceType[FaceType["\u6D41\u6CEA"] = 5] = "\u6D41\u6CEA";
    FaceType[FaceType["HAI_XIU"] = 6] = "HAI_XIU";
    FaceType[FaceType["\u5BB3\u7F9E"] = 6] = "\u5BB3\u7F9E";
    FaceType[FaceType["BI_ZUI"] = 7] = "BI_ZUI";
    FaceType[FaceType["\u95ED\u5634"] = 7] = "\u95ED\u5634";
    FaceType[FaceType["SHUI"] = 8] = "SHUI";
    FaceType[FaceType["\u7761"] = 8] = "\u7761";
    FaceType[FaceType["DA_KU"] = 9] = "DA_KU";
    FaceType[FaceType["\u5927\u54ED"] = 9] = "\u5927\u54ED";
    FaceType[FaceType["GAN_GA"] = 10] = "GAN_GA";
    FaceType[FaceType["\u5C34\u5C2C"] = 10] = "\u5C34\u5C2C";
    FaceType[FaceType["FA_NU"] = 11] = "FA_NU";
    FaceType[FaceType["\u53D1\u6012"] = 11] = "\u53D1\u6012";
    FaceType[FaceType["TIAO_PI"] = 12] = "TIAO_PI";
    FaceType[FaceType["\u8C03\u76AE"] = 12] = "\u8C03\u76AE";
    FaceType[FaceType["ZI_YA"] = 13] = "ZI_YA";
    FaceType[FaceType["\u5472\u7259"] = 13] = "\u5472\u7259";
    FaceType[FaceType["WEI_XIAO"] = 14] = "WEI_XIAO";
    FaceType[FaceType["\u5FAE\u7B11"] = 14] = "\u5FAE\u7B11";
    FaceType[FaceType["NAN_GUO"] = 15] = "NAN_GUO";
    FaceType[FaceType["\u96BE\u8FC7"] = 15] = "\u96BE\u8FC7";
    FaceType[FaceType["KU"] = 16] = "KU";
    FaceType[FaceType["\u9177"] = 16] = "\u9177";
    FaceType[FaceType["ZHUA_KUANG"] = 18] = "ZHUA_KUANG";
    FaceType[FaceType["\u6293\u72C2"] = 18] = "\u6293\u72C2";
    FaceType[FaceType["TU"] = 19] = "TU";
    FaceType[FaceType["\u5410"] = 19] = "\u5410";
    FaceType[FaceType["TOU_XIAO"] = 20] = "TOU_XIAO";
    FaceType[FaceType["\u5077\u7B11"] = 20] = "\u5077\u7B11";
    FaceType[FaceType["KE_AI"] = 21] = "KE_AI";
    FaceType[FaceType["\u53EF\u7231"] = 21] = "\u53EF\u7231";
    FaceType[FaceType["BAI_YAN"] = 22] = "BAI_YAN";
    FaceType[FaceType["\u767D\u773C"] = 22] = "\u767D\u773C";
    FaceType[FaceType["AO_MAN"] = 23] = "AO_MAN";
    FaceType[FaceType["\u50B2\u6162"] = 23] = "\u50B2\u6162";
    FaceType[FaceType["JI_E"] = 24] = "JI_E";
    FaceType[FaceType["\u9965\u997F"] = 24] = "\u9965\u997F";
    FaceType[FaceType["KUN"] = 25] = "KUN";
    FaceType[FaceType["\u56F0"] = 25] = "\u56F0";
    FaceType[FaceType["JING_KONG"] = 26] = "JING_KONG";
    FaceType[FaceType["\u60CA\u6050"] = 26] = "\u60CA\u6050";
    FaceType[FaceType["LIU_HAN"] = 27] = "LIU_HAN";
    FaceType[FaceType["\u6D41\u6C57"] = 27] = "\u6D41\u6C57";
    FaceType[FaceType["HAN_XIAO"] = 28] = "HAN_XIAO";
    FaceType[FaceType["\u61A8\u7B11"] = 28] = "\u61A8\u7B11";
    FaceType[FaceType["YOU_XIAN"] = 29] = "YOU_XIAN";
    FaceType[FaceType["\u60A0\u95F2"] = 29] = "\u60A0\u95F2";
    FaceType[FaceType["FEN_DOU"] = 30] = "FEN_DOU";
    FaceType[FaceType["\u594B\u6597"] = 30] = "\u594B\u6597";
    FaceType[FaceType["ZHOU_MA"] = 31] = "ZHOU_MA";
    FaceType[FaceType["\u5492\u9A82"] = 31] = "\u5492\u9A82";
    FaceType[FaceType["YI_WEN"] = 32] = "YI_WEN";
    FaceType[FaceType["\u7591\u95EE"] = 32] = "\u7591\u95EE";
    FaceType[FaceType["XU"] = 33] = "XU";
    FaceType[FaceType["\u5618"] = 33] = "\u5618";
    FaceType[FaceType["YUN"] = 34] = "YUN";
    FaceType[FaceType["\u6655"] = 34] = "\u6655";
    FaceType[FaceType["ZHE_MO"] = 35] = "ZHE_MO";
    FaceType[FaceType["\u6298\u78E8"] = 35] = "\u6298\u78E8";
    FaceType[FaceType["SHUAI"] = 36] = "SHUAI";
    FaceType[FaceType["\u8870"] = 36] = "\u8870";
    FaceType[FaceType["KU_LOU"] = 37] = "KU_LOU";
    FaceType[FaceType["\u9AB7\u9AC5"] = 37] = "\u9AB7\u9AC5";
    FaceType[FaceType["QIAO_DA"] = 38] = "QIAO_DA";
    FaceType[FaceType["\u6572\u6253"] = 38] = "\u6572\u6253";
    FaceType[FaceType["ZAI_JIAN"] = 39] = "ZAI_JIAN";
    FaceType[FaceType["\u518D\u89C1"] = 39] = "\u518D\u89C1";
    FaceType[FaceType["FA_DOU"] = 41] = "FA_DOU";
    FaceType[FaceType["\u53D1\u6296"] = 41] = "\u53D1\u6296";
    FaceType[FaceType["AI_QING"] = 42] = "AI_QING";
    FaceType[FaceType["\u7231\u60C5"] = 42] = "\u7231\u60C5";
    FaceType[FaceType["TIAO_TIAO"] = 43] = "TIAO_TIAO";
    FaceType[FaceType["\u8DF3\u8DF3"] = 43] = "\u8DF3\u8DF3";
    FaceType[FaceType["ZHU_TOU"] = 46] = "ZHU_TOU";
    FaceType[FaceType["\u732A\u5934"] = 46] = "\u732A\u5934";
    FaceType[FaceType["YONG_BAO"] = 49] = "YONG_BAO";
    FaceType[FaceType["\u62E5\u62B1"] = 49] = "\u62E5\u62B1";
    FaceType[FaceType["DAN_GAO"] = 53] = "DAN_GAO";
    FaceType[FaceType["\u86CB\u7CD5"] = 53] = "\u86CB\u7CD5";
    FaceType[FaceType["SHAN_DIAN"] = 54] = "SHAN_DIAN";
    FaceType[FaceType["\u95EA\u7535"] = 54] = "\u95EA\u7535";
    FaceType[FaceType["ZHA_DAN"] = 55] = "ZHA_DAN";
    FaceType[FaceType["\u70B8\u5F39"] = 55] = "\u70B8\u5F39";
    FaceType[FaceType["DAO"] = 56] = "DAO";
    FaceType[FaceType["\u5200"] = 56] = "\u5200";
    FaceType[FaceType["ZU_QIU"] = 57] = "ZU_QIU";
    FaceType[FaceType["\u8DB3\u7403"] = 57] = "\u8DB3\u7403";
    FaceType[FaceType["BIAN_BIAN"] = 59] = "BIAN_BIAN";
    FaceType[FaceType["\u4FBF\u4FBF"] = 59] = "\u4FBF\u4FBF";
    FaceType[FaceType["KA_FEI"] = 60] = "KA_FEI";
    FaceType[FaceType["\u5496\u5561"] = 60] = "\u5496\u5561";
    FaceType[FaceType["FAN"] = 61] = "FAN";
    FaceType[FaceType["\u996D"] = 61] = "\u996D";
    FaceType[FaceType["MEI_GUI"] = 63] = "MEI_GUI";
    FaceType[FaceType["\u73AB\u7470"] = 63] = "\u73AB\u7470";
    FaceType[FaceType["DIAO_XIE"] = 64] = "DIAO_XIE";
    FaceType[FaceType["\u51CB\u8C22"] = 64] = "\u51CB\u8C22";
    FaceType[FaceType["AI_XIN"] = 66] = "AI_XIN";
    FaceType[FaceType["\u7231\u5FC3"] = 66] = "\u7231\u5FC3";
    FaceType[FaceType["XIN_SUI"] = 67] = "XIN_SUI";
    FaceType[FaceType["\u5FC3\u788E"] = 67] = "\u5FC3\u788E";
    FaceType[FaceType["LI_WU"] = 69] = "LI_WU";
    FaceType[FaceType["\u793C\u7269"] = 69] = "\u793C\u7269";
    FaceType[FaceType["TAI_YANG"] = 74] = "TAI_YANG";
    FaceType[FaceType["\u592A\u9633"] = 74] = "\u592A\u9633";
    FaceType[FaceType["YUE_LIANG"] = 75] = "YUE_LIANG";
    FaceType[FaceType["\u6708\u4EAE"] = 75] = "\u6708\u4EAE";
    FaceType[FaceType["ZAN"] = 76] = "ZAN";
    FaceType[FaceType["\u8D5E"] = 76] = "\u8D5E";
    FaceType[FaceType["CAI"] = 77] = "CAI";
    FaceType[FaceType["\u8E29"] = 77] = "\u8E29";
    FaceType[FaceType["WO_SHOU"] = 78] = "WO_SHOU";
    FaceType[FaceType["\u63E1\u624B"] = 78] = "\u63E1\u624B";
    FaceType[FaceType["SHENG_LI"] = 79] = "SHENG_LI";
    FaceType[FaceType["\u80DC\u5229"] = 79] = "\u80DC\u5229";
    FaceType[FaceType["FEI_WEN"] = 85] = "FEI_WEN";
    FaceType[FaceType["\u98DE\u543B"] = 85] = "\u98DE\u543B";
    FaceType[FaceType["OU_HUO"] = 86] = "OU_HUO";
    FaceType[FaceType["\u6004\u706B"] = 86] = "\u6004\u706B";
    FaceType[FaceType["XI_GUA"] = 89] = "XI_GUA";
    FaceType[FaceType["\u897F\u74DC"] = 89] = "\u897F\u74DC";
    FaceType[FaceType["LENG_HAN"] = 96] = "LENG_HAN";
    FaceType[FaceType["\u51B7\u6C57"] = 96] = "\u51B7\u6C57";
    FaceType[FaceType["CA_HAN"] = 97] = "CA_HAN";
    FaceType[FaceType["\u64E6\u6C57"] = 97] = "\u64E6\u6C57";
    FaceType[FaceType["KOU_BI"] = 98] = "KOU_BI";
    FaceType[FaceType["\u62A0\u9F3B"] = 98] = "\u62A0\u9F3B";
    FaceType[FaceType["GU_ZHANG"] = 99] = "GU_ZHANG";
    FaceType[FaceType["\u9F13\u638C"] = 99] = "\u9F13\u638C";
    FaceType[FaceType["QIU_DA_LE"] = 100] = "QIU_DA_LE";
    FaceType[FaceType["\u7CD7\u5927\u4E86"] = 100] = "\u7CD7\u5927\u4E86";
    FaceType[FaceType["HUAI_XIAO"] = 101] = "HUAI_XIAO";
    FaceType[FaceType["\u574F\u7B11"] = 101] = "\u574F\u7B11";
    FaceType[FaceType["ZUO_HENG_HENG"] = 102] = "ZUO_HENG_HENG";
    FaceType[FaceType["\u5DE6\u54FC\u54FC"] = 102] = "\u5DE6\u54FC\u54FC";
    FaceType[FaceType["YOU_HENG_HENG"] = 103] = "YOU_HENG_HENG";
    FaceType[FaceType["\u53F3\u54FC\u54FC"] = 103] = "\u53F3\u54FC\u54FC";
    FaceType[FaceType["HA_QIAN"] = 104] = "HA_QIAN";
    FaceType[FaceType["\u54C8\u6B20"] = 104] = "\u54C8\u6B20";
    FaceType[FaceType["BI_SHI"] = 105] = "BI_SHI";
    FaceType[FaceType["\u9119\u89C6"] = 105] = "\u9119\u89C6";
    FaceType[FaceType["WEI_QU"] = 106] = "WEI_QU";
    FaceType[FaceType["\u59D4\u5C48"] = 106] = "\u59D4\u5C48";
    FaceType[FaceType["KUAI_KU_LE"] = 107] = "KUAI_KU_LE";
    FaceType[FaceType["\u5FEB\u54ED\u4E86"] = 107] = "\u5FEB\u54ED\u4E86";
    FaceType[FaceType["YIN_XIAN"] = 108] = "YIN_XIAN";
    FaceType[FaceType["\u9634\u9669"] = 108] = "\u9634\u9669";
    FaceType[FaceType["QIN_QIN"] = 109] = "QIN_QIN";
    FaceType[FaceType["\u4EB2\u4EB2"] = 109] = "\u4EB2\u4EB2";
    FaceType[FaceType["XIA"] = 110] = "XIA";
    FaceType[FaceType["\u5413"] = 110] = "\u5413";
    FaceType[FaceType["KE_LIAN"] = 111] = "KE_LIAN";
    FaceType[FaceType["\u53EF\u601C"] = 111] = "\u53EF\u601C";
    FaceType[FaceType["CAI_DAO"] = 112] = "CAI_DAO";
    FaceType[FaceType["\u83DC\u5200"] = 112] = "\u83DC\u5200";
    FaceType[FaceType["PI_JIU"] = 113] = "PI_JIU";
    FaceType[FaceType["\u5564\u9152"] = 113] = "\u5564\u9152";
    FaceType[FaceType["LAN_QIU"] = 114] = "LAN_QIU";
    FaceType[FaceType["\u7BEE\u7403"] = 114] = "\u7BEE\u7403";
    FaceType[FaceType["PING_PANG"] = 115] = "PING_PANG";
    FaceType[FaceType["\u4E52\u4E53"] = 115] = "\u4E52\u4E53";
    FaceType[FaceType["SHI_AI"] = 116] = "SHI_AI";
    FaceType[FaceType["\u793A\u7231"] = 116] = "\u793A\u7231";
    FaceType[FaceType["PIAO_CHONG"] = 117] = "PIAO_CHONG";
    FaceType[FaceType["\u74E2\u866B"] = 117] = "\u74E2\u866B";
    FaceType[FaceType["BAO_QUAN"] = 118] = "BAO_QUAN";
    FaceType[FaceType["\u62B1\u62F3"] = 118] = "\u62B1\u62F3";
    FaceType[FaceType["GOU_YIN"] = 119] = "GOU_YIN";
    FaceType[FaceType["\u52FE\u5F15"] = 119] = "\u52FE\u5F15";
    FaceType[FaceType["QUAN_TOU"] = 120] = "QUAN_TOU";
    FaceType[FaceType["\u62F3\u5934"] = 120] = "\u62F3\u5934";
    FaceType[FaceType["CHA_JIN"] = 121] = "CHA_JIN";
    FaceType[FaceType["\u5DEE\u52B2"] = 121] = "\u5DEE\u52B2";
    FaceType[FaceType["AI_NI"] = 122] = "AI_NI";
    FaceType[FaceType["\u7231\u4F60"] = 122] = "\u7231\u4F60";
    FaceType[FaceType["NO"] = 123] = "NO";
    FaceType[FaceType["BU"] = 123] = "BU";
    FaceType[FaceType["\u4E0D"] = 123] = "\u4E0D";
    FaceType[FaceType["OK"] = 124] = "OK";
    FaceType[FaceType["HAO"] = 124] = "HAO";
    FaceType[FaceType["\u597D"] = 124] = "\u597D";
    FaceType[FaceType["ZHUAN_QUAN"] = 125] = "ZHUAN_QUAN";
    FaceType[FaceType["\u8F6C\u5708"] = 125] = "\u8F6C\u5708";
    FaceType[FaceType["KE_TOU"] = 126] = "KE_TOU";
    FaceType[FaceType["\u78D5\u5934"] = 126] = "\u78D5\u5934";
    FaceType[FaceType["HUI_TOU"] = 127] = "HUI_TOU";
    FaceType[FaceType["\u56DE\u5934"] = 127] = "\u56DE\u5934";
    FaceType[FaceType["TIAO_SHENG"] = 128] = "TIAO_SHENG";
    FaceType[FaceType["\u8DF3\u7EF3"] = 128] = "\u8DF3\u7EF3";
    FaceType[FaceType["HUI_SHOU"] = 129] = "HUI_SHOU";
    FaceType[FaceType["\u6325\u624B"] = 129] = "\u6325\u624B";
    FaceType[FaceType["JI_DONG"] = 130] = "JI_DONG";
    FaceType[FaceType["\u6FC0\u52A8"] = 130] = "\u6FC0\u52A8";
    FaceType[FaceType["JIE_WU"] = 131] = "JIE_WU";
    FaceType[FaceType["\u8857\u821E"] = 131] = "\u8857\u821E";
    FaceType[FaceType["XIAN_WEN"] = 132] = "XIAN_WEN";
    FaceType[FaceType["\u732E\u543B"] = 132] = "\u732E\u543B";
    FaceType[FaceType["ZUO_TAI_JI"] = 133] = "ZUO_TAI_JI";
    FaceType[FaceType["\u5DE6\u592A\u6781"] = 133] = "\u5DE6\u592A\u6781";
    FaceType[FaceType["YOU_TAI_JI"] = 134] = "YOU_TAI_JI";
    FaceType[FaceType["\u53F3\u592A\u6781"] = 134] = "\u53F3\u592A\u6781";
    FaceType[FaceType["SHUANG_XI"] = 136] = "SHUANG_XI";
    FaceType[FaceType["\u53CC\u559C"] = 136] = "\u53CC\u559C";
    FaceType[FaceType["BIAN_PAO"] = 137] = "BIAN_PAO";
    FaceType[FaceType["\u97AD\u70AE"] = 137] = "\u97AD\u70AE";
    FaceType[FaceType["DENG_LONG"] = 138] = "DENG_LONG";
    FaceType[FaceType["\u706F\u7B3C"] = 138] = "\u706F\u7B3C";
    FaceType[FaceType["K_GE"] = 140] = "K_GE";
    FaceType[FaceType["K\u6B4C"] = 140] = "K\u6B4C";
    FaceType[FaceType["HE_CAI"] = 144] = "HE_CAI";
    FaceType[FaceType["\u559D\u5F69"] = 144] = "\u559D\u5F69";
    FaceType[FaceType["QI_DAO"] = 145] = "QI_DAO";
    FaceType[FaceType["\u7948\u7977"] = 145] = "\u7948\u7977";
    FaceType[FaceType["BAO_JIN"] = 146] = "BAO_JIN";
    FaceType[FaceType["\u7206\u7B4B"] = 146] = "\u7206\u7B4B";
    FaceType[FaceType["BANG_BANG_TANG"] = 147] = "BANG_BANG_TANG";
    FaceType[FaceType["\u68D2\u68D2\u7CD6"] = 147] = "\u68D2\u68D2\u7CD6";
    FaceType[FaceType["HE_NAI"] = 148] = "HE_NAI";
    FaceType[FaceType["\u559D\u5976"] = 148] = "\u559D\u5976";
    FaceType[FaceType["FEI_JI"] = 151] = "FEI_JI";
    FaceType[FaceType["\u98DE\u673A"] = 151] = "\u98DE\u673A";
    FaceType[FaceType["CHAO_PIAO"] = 158] = "CHAO_PIAO";
    FaceType[FaceType["\u949E\u7968"] = 158] = "\u949E\u7968";
    FaceType[FaceType["YAO"] = 168] = "YAO";
    FaceType[FaceType["\u836F"] = 168] = "\u836F";
    FaceType[FaceType["SHOU_QIANG"] = 169] = "SHOU_QIANG";
    FaceType[FaceType["\u624B\u67AA"] = 169] = "\u624B\u67AA";
    FaceType[FaceType["CHA"] = 171] = "CHA";
    FaceType[FaceType["\u8336"] = 171] = "\u8336";
    FaceType[FaceType["ZHA_YAN_JING"] = 172] = "ZHA_YAN_JING";
    FaceType[FaceType["\u7728\u773C\u775B"] = 172] = "\u7728\u773C\u775B";
    FaceType[FaceType["LEI_BEN"] = 173] = "LEI_BEN";
    FaceType[FaceType["\u6CEA\u5954"] = 173] = "\u6CEA\u5954";
    FaceType[FaceType["WU_NAI"] = 174] = "WU_NAI";
    FaceType[FaceType["\u65E0\u5948"] = 174] = "\u65E0\u5948";
    FaceType[FaceType["MAI_MENG"] = 175] = "MAI_MENG";
    FaceType[FaceType["\u5356\u840C"] = 175] = "\u5356\u840C";
    FaceType[FaceType["XIAO_JIU_JIE"] = 176] = "XIAO_JIU_JIE";
    FaceType[FaceType["\u5C0F\u7EA0\u7ED3"] = 176] = "\u5C0F\u7EA0\u7ED3";
    FaceType[FaceType["PEN_XIE"] = 177] = "PEN_XIE";
    FaceType[FaceType["\u55B7\u8840"] = 177] = "\u55B7\u8840";
    FaceType[FaceType["XIE_YAN_XIAO"] = 178] = "XIE_YAN_XIAO";
    FaceType[FaceType["\u659C\u773C\u7B11"] = 178] = "\u659C\u773C\u7B11";
    FaceType[FaceType["doge"] = 179] = "doge";
    FaceType[FaceType["JING_XI"] = 180] = "JING_XI";
    FaceType[FaceType["\u60CA\u559C"] = 180] = "\u60CA\u559C";
    FaceType[FaceType["SAO_RAO"] = 181] = "SAO_RAO";
    FaceType[FaceType["\u9A9A\u6270"] = 181] = "\u9A9A\u6270";
    FaceType[FaceType["XIAO_KU"] = 182] = "XIAO_KU";
    FaceType[FaceType["\u7B11\u54ED"] = 182] = "\u7B11\u54ED";
    FaceType[FaceType["WO_ZUI_MEI"] = 183] = "WO_ZUI_MEI";
    FaceType[FaceType["\u6211\u6700\u7F8E"] = 183] = "\u6211\u6700\u7F8E";
    FaceType[FaceType["HE_XIE"] = 184] = "HE_XIE";
    FaceType[FaceType["\u6CB3\u87F9"] = 184] = "\u6CB3\u87F9";
    FaceType[FaceType["YANG_TUO"] = 185] = "YANG_TUO";
    FaceType[FaceType["\u7F8A\u9A7C"] = 185] = "\u7F8A\u9A7C";
    FaceType[FaceType["YOU_LING"] = 187] = "YOU_LING";
    FaceType[FaceType["\u5E7D\u7075"] = 187] = "\u5E7D\u7075";
    FaceType[FaceType["DAN"] = 188] = "DAN";
    FaceType[FaceType["\u86CB"] = 188] = "\u86CB";
    FaceType[FaceType["JU_HUA"] = 190] = "JU_HUA";
    FaceType[FaceType["\u83CA\u82B1"] = 190] = "\u83CA\u82B1";
    FaceType[FaceType["HONG_BAO"] = 192] = "HONG_BAO";
    FaceType[FaceType["\u7EA2\u5305"] = 192] = "\u7EA2\u5305";
    FaceType[FaceType["DA_XIAO"] = 193] = "DA_XIAO";
    FaceType[FaceType["\u5927\u7B11"] = 193] = "\u5927\u7B11";
    FaceType[FaceType["BU_KAI_XIN"] = 194] = "BU_KAI_XIN";
    FaceType[FaceType["\u4E0D\u5F00\u5FC3"] = 194] = "\u4E0D\u5F00\u5FC3";
    FaceType[FaceType["LENG_MO"] = 197] = "LENG_MO";
    FaceType[FaceType["\u51B7\u6F20"] = 197] = "\u51B7\u6F20";
    FaceType[FaceType["E"] = 198] = "E";
    FaceType[FaceType["\u5443"] = 198] = "\u5443";
    FaceType[FaceType["HAO_BANG"] = 199] = "HAO_BANG";
    FaceType[FaceType["\u597D\u68D2"] = 199] = "\u597D\u68D2";
    FaceType[FaceType["BAI_TUO"] = 200] = "BAI_TUO";
    FaceType[FaceType["\u62DC\u6258"] = 200] = "\u62DC\u6258";
    FaceType[FaceType["DIAN_ZAN"] = 201] = "DIAN_ZAN";
    FaceType[FaceType["\u70B9\u8D5E"] = 201] = "\u70B9\u8D5E";
    FaceType[FaceType["WU_LIAO"] = 202] = "WU_LIAO";
    FaceType[FaceType["\u65E0\u804A"] = 202] = "\u65E0\u804A";
    FaceType[FaceType["TUO_LIAN"] = 203] = "TUO_LIAN";
    FaceType[FaceType["\u6258\u8138"] = 203] = "\u6258\u8138";
    FaceType[FaceType["CHI"] = 204] = "CHI";
    FaceType[FaceType["\u5403"] = 204] = "\u5403";
    FaceType[FaceType["SONG_HUA"] = 205] = "SONG_HUA";
    FaceType[FaceType["\u9001\u82B1"] = 205] = "\u9001\u82B1";
    FaceType[FaceType["HAI_PA"] = 206] = "HAI_PA";
    FaceType[FaceType["\u5BB3\u6015"] = 206] = "\u5BB3\u6015";
    FaceType[FaceType["HUA_CHI"] = 207] = "HUA_CHI";
    FaceType[FaceType["\u82B1\u75F4"] = 207] = "\u82B1\u75F4";
    FaceType[FaceType["XIAO_YANG_ER"] = 208] = "XIAO_YANG_ER";
    FaceType[FaceType["\u5C0F\u6837\u513F"] = 208] = "\u5C0F\u6837\u513F";
    FaceType[FaceType["BIAO_LEI"] = 210] = "BIAO_LEI";
    FaceType[FaceType["\u98D9\u6CEA"] = 210] = "\u98D9\u6CEA";
    FaceType[FaceType["WO_BU_KAN"] = 211] = "WO_BU_KAN";
    FaceType[FaceType["\u6211\u4E0D\u770B"] = 211] = "\u6211\u4E0D\u770B";
    FaceType[FaceType["TUO_SAI"] = 212] = "TUO_SAI";
    FaceType[FaceType["\u6258\u816E"] = 212] = "\u6258\u816E";
    FaceType[FaceType["BO_BO"] = 214] = "BO_BO";
    FaceType[FaceType["\u5575\u5575"] = 214] = "\u5575\u5575";
    FaceType[FaceType["HU_LIAN"] = 215] = "HU_LIAN";
    FaceType[FaceType["\u7CCA\u8138"] = 215] = "\u7CCA\u8138";
    FaceType[FaceType["PAI_TOU"] = 216] = "PAI_TOU";
    FaceType[FaceType["\u62CD\u5934"] = 216] = "\u62CD\u5934";
    FaceType[FaceType["CHE_YI_CHE"] = 217] = "CHE_YI_CHE";
    FaceType[FaceType["\u626F\u4E00\u626F"] = 217] = "\u626F\u4E00\u626F";
    FaceType[FaceType["TIAN_YI_TIAN"] = 218] = "TIAN_YI_TIAN";
    FaceType[FaceType["\u8214\u4E00\u8214"] = 218] = "\u8214\u4E00\u8214";
    FaceType[FaceType["CENG_YI_CENG"] = 219] = "CENG_YI_CENG";
    FaceType[FaceType["\u8E6D\u4E00\u8E6D"] = 219] = "\u8E6D\u4E00\u8E6D";
    FaceType[FaceType["ZHUAI_ZHA_TIAN"] = 220] = "ZHUAI_ZHA_TIAN";
    FaceType[FaceType["\u62FD\u70B8\u5929"] = 220] = "\u62FD\u70B8\u5929";
    FaceType[FaceType["DING_GUA_GUA"] = 221] = "DING_GUA_GUA";
    FaceType[FaceType["\u9876\u5471\u5471"] = 221] = "\u9876\u5471\u5471";
    FaceType[FaceType["BAO_BAO"] = 222] = "BAO_BAO";
    FaceType[FaceType["\u62B1\u62B1"] = 222] = "\u62B1\u62B1";
    FaceType[FaceType["BAO_JI"] = 223] = "BAO_JI";
    FaceType[FaceType["\u66B4\u51FB"] = 223] = "\u66B4\u51FB";
    FaceType[FaceType["KAI_QIANG"] = 224] = "KAI_QIANG";
    FaceType[FaceType["\u5F00\u67AA"] = 224] = "\u5F00\u67AA";
    FaceType[FaceType["LIAO_YI_LIAO"] = 225] = "LIAO_YI_LIAO";
    FaceType[FaceType["\u64A9\u4E00\u64A9"] = 225] = "\u64A9\u4E00\u64A9";
    FaceType[FaceType["PAI_ZHUO"] = 226] = "PAI_ZHUO";
    FaceType[FaceType["\u62CD\u684C"] = 226] = "\u62CD\u684C";
    FaceType[FaceType["PAI_SHOU"] = 227] = "PAI_SHOU";
    FaceType[FaceType["\u62CD\u624B"] = 227] = "\u62CD\u624B";
    FaceType[FaceType["GONG_XI"] = 228] = "GONG_XI";
    FaceType[FaceType["\u606D\u559C"] = 228] = "\u606D\u559C";
    FaceType[FaceType["GAN_BEI"] = 229] = "GAN_BEI";
    FaceType[FaceType["\u5E72\u676F"] = 229] = "\u5E72\u676F";
    FaceType[FaceType["CHAO_FENG"] = 230] = "CHAO_FENG";
    FaceType[FaceType["\u5632\u8BBD"] = 230] = "\u5632\u8BBD";
    FaceType[FaceType["HENG"] = 231] = "HENG";
    FaceType[FaceType["\u54FC"] = 231] = "\u54FC";
    FaceType[FaceType["FO_XI"] = 232] = "FO_XI";
    FaceType[FaceType["\u4F5B\u7CFB"] = 232] = "\u4F5B\u7CFB";
    FaceType[FaceType["QIA_YI_QIA"] = 233] = "QIA_YI_QIA";
    FaceType[FaceType["\u6390\u4E00\u6390"] = 233] = "\u6390\u4E00\u6390";
    FaceType[FaceType["JING_DAI"] = 234] = "JING_DAI";
    FaceType[FaceType["\u60CA\u5446"] = 234] = "\u60CA\u5446";
    FaceType[FaceType["CHAN_DOU"] = 235] = "CHAN_DOU";
    FaceType[FaceType["\u98A4\u6296"] = 235] = "\u98A4\u6296";
    FaceType[FaceType["KEN_TOU"] = 236] = "KEN_TOU";
    FaceType[FaceType["\u5543\u5934"] = 236] = "\u5543\u5934";
    FaceType[FaceType["TOU_KAN"] = 237] = "TOU_KAN";
    FaceType[FaceType["\u5077\u770B"] = 237] = "\u5077\u770B";
    FaceType[FaceType["SHAN_LIAN"] = 238] = "SHAN_LIAN";
    FaceType[FaceType["\u6247\u8138"] = 238] = "\u6247\u8138";
    FaceType[FaceType["YUAN_LIANG"] = 239] = "YUAN_LIANG";
    FaceType[FaceType["\u539F\u8C05"] = 239] = "\u539F\u8C05";
    FaceType[FaceType["PEN_LIAN"] = 240] = "PEN_LIAN";
    FaceType[FaceType["\u55B7\u8138"] = 240] = "\u55B7\u8138";
    FaceType[FaceType["SHENG_RI_KUAI_LE"] = 241] = "SHENG_RI_KUAI_LE";
    FaceType[FaceType["\u751F\u65E5\u5FEB\u4E50"] = 241] = "\u751F\u65E5\u5FEB\u4E50";
    FaceType[FaceType["TOU_ZHUANG_JI"] = 242] = "TOU_ZHUANG_JI";
    FaceType[FaceType["\u5934\u649E\u51FB"] = 242] = "\u5934\u649E\u51FB";
    FaceType[FaceType["SHUAI_TOU"] = 243] = "SHUAI_TOU";
    FaceType[FaceType["\u7529\u5934"] = 243] = "\u7529\u5934";
    FaceType[FaceType["RENG_GOU"] = 244] = "RENG_GOU";
    FaceType[FaceType["\u6254\u72D7"] = 244] = "\u6254\u72D7";
    FaceType[FaceType["JIA_YOU_BI_SHENG"] = 245] = "JIA_YOU_BI_SHENG";
    FaceType[FaceType["\u52A0\u6CB9\u5FC5\u80DC"] = 245] = "\u52A0\u6CB9\u5FC5\u80DC";
    FaceType[FaceType["JIA_YOU_BAO_BAO"] = 246] = "JIA_YOU_BAO_BAO";
    FaceType[FaceType["\u52A0\u6CB9\u62B1\u62B1"] = 246] = "\u52A0\u6CB9\u62B1\u62B1";
    FaceType[FaceType["KOU_ZHAO_HU_TI"] = 247] = "KOU_ZHAO_HU_TI";
    FaceType[FaceType["\u53E3\u7F69\u62A4\u4F53"] = 247] = "\u53E3\u7F69\u62A4\u4F53";
    FaceType[FaceType["BAN_ZHUAN_ZHONG"] = 260] = "BAN_ZHUAN_ZHONG";
    FaceType[FaceType["\u642C\u7816\u4E2D"] = 260] = "\u642C\u7816\u4E2D";
    FaceType[FaceType["MANG_DAO_FEI_QI"] = 261] = "MANG_DAO_FEI_QI";
    FaceType[FaceType["\u5FD9\u5230\u98DE\u8D77"] = 261] = "\u5FD9\u5230\u98DE\u8D77";
    FaceType[FaceType["NAO_KUO_TENG"] = 262] = "NAO_KUO_TENG";
    FaceType[FaceType["\u8111\u9614\u75BC"] = 262] = "\u8111\u9614\u75BC";
    FaceType[FaceType["CANG_SANG"] = 263] = "CANG_SANG";
    FaceType[FaceType["\u6CA7\u6851"] = 263] = "\u6CA7\u6851";
    FaceType[FaceType["WU_LIAN"] = 264] = "WU_LIAN";
    FaceType[FaceType["\u6342\u8138"] = 264] = "\u6342\u8138";
    FaceType[FaceType["LA_YAN_JING"] = 265] = "LA_YAN_JING";
    FaceType[FaceType["\u8FA3\u773C\u775B"] = 265] = "\u8FA3\u773C\u775B";
    FaceType[FaceType["O_YO"] = 266] = "O_YO";
    FaceType[FaceType["\u54E6\u54DF"] = 266] = "\u54E6\u54DF";
    FaceType[FaceType["TOU_TU"] = 267] = "TOU_TU";
    FaceType[FaceType["\u5934\u79C3"] = 267] = "\u5934\u79C3";
    FaceType[FaceType["WEN_HAO_LIAN"] = 268] = "WEN_HAO_LIAN";
    FaceType[FaceType["\u95EE\u53F7\u8138"] = 268] = "\u95EE\u53F7\u8138";
    FaceType[FaceType["AN_ZHONG_GUAN_CHA"] = 269] = "AN_ZHONG_GUAN_CHA";
    FaceType[FaceType["\u6697\u4E2D\u89C2\u5BDF"] = 269] = "\u6697\u4E2D\u89C2\u5BDF";
    FaceType[FaceType["EMM"] = 270] = "EMM";
    FaceType[FaceType["emm"] = 270] = "emm";
    FaceType[FaceType["CHI_GUA"] = 271] = "CHI_GUA";
    FaceType[FaceType["\u5403\u74DC"] = 271] = "\u5403\u74DC";
    FaceType[FaceType["HE_HE_DA"] = 272] = "HE_HE_DA";
    FaceType[FaceType["\u5475\u5475\u54D2"] = 272] = "\u5475\u5475\u54D2";
    FaceType[FaceType["WO_SUAN_LE"] = 273] = "WO_SUAN_LE";
    FaceType[FaceType["\u6211\u9178\u4E86"] = 273] = "\u6211\u9178\u4E86";
    FaceType[FaceType["TAI_NAN_LE"] = 274] = "TAI_NAN_LE";
    FaceType[FaceType["\u592A\u5357\u4E86"] = 274] = "\u592A\u5357\u4E86";
    FaceType[FaceType["LA_JIAO_JIANG"] = 276] = "LA_JIAO_JIANG";
    FaceType[FaceType["\u8FA3\u6912\u9171"] = 276] = "\u8FA3\u6912\u9171";
    FaceType[FaceType["WANG_WANG"] = 277] = "WANG_WANG";
    FaceType[FaceType["\u6C6A\u6C6A"] = 277] = "\u6C6A\u6C6A";
    FaceType[FaceType["HAN"] = 278] = "HAN";
    FaceType[FaceType["\u6C57"] = 278] = "\u6C57";
    FaceType[FaceType["DA_LIAN"] = 279] = "DA_LIAN";
    FaceType[FaceType["\u6253\u8138"] = 279] = "\u6253\u8138";
    FaceType[FaceType["JI_ZHANG"] = 280] = "JI_ZHANG";
    FaceType[FaceType["\u51FB\u638C"] = 280] = "\u51FB\u638C";
    FaceType[FaceType["WU_YAN_XIAO"] = 281] = "WU_YAN_XIAO";
    FaceType[FaceType["\u65E0\u773C\u7B11"] = 281] = "\u65E0\u773C\u7B11";
    FaceType[FaceType["JING_LI"] = 282] = "JING_LI";
    FaceType[FaceType["\u656C\u793C"] = 282] = "\u656C\u793C";
    FaceType[FaceType["KUANG_XIAO"] = 283] = "KUANG_XIAO";
    FaceType[FaceType["\u72C2\u7B11"] = 283] = "\u72C2\u7B11";
    FaceType[FaceType["MIAN_WU_BIAO_QING"] = 284] = "MIAN_WU_BIAO_QING";
    FaceType[FaceType["\u9762\u65E0\u8868\u60C5"] = 284] = "\u9762\u65E0\u8868\u60C5";
    FaceType[FaceType["MO_YU"] = 285] = "MO_YU";
    FaceType[FaceType["\u6478\u9C7C"] = 285] = "\u6478\u9C7C";
    FaceType[FaceType["MO_GUI_XIAO"] = 286] = "MO_GUI_XIAO";
    FaceType[FaceType["\u9B54\u9B3C\u7B11"] = 286] = "\u9B54\u9B3C\u7B11";
    FaceType[FaceType["O"] = 287] = "O";
    FaceType[FaceType["\u54E6"] = 287] = "\u54E6";
    FaceType[FaceType["QING"] = 288] = "QING";
    FaceType[FaceType["\u8BF7"] = 288] = "\u8BF7";
    FaceType[FaceType["ZHENG_YAN"] = 289] = "ZHENG_YAN";
    FaceType[FaceType["\u7741\u773C"] = 289] = "\u7741\u773C";
})(FaceType = exports.FaceType || (exports.FaceType = {}));
/** mirai-api-http请求返回的状态码 */
var ResponseCode;
(function (ResponseCode) {
    /** 正常 */
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    /** 错误的verify key */
    ResponseCode[ResponseCode["WrongVerifyKey"] = 1] = "WrongVerifyKey";
    /** 指定的Bot不存在 */
    ResponseCode[ResponseCode["BotNotExist"] = 2] = "BotNotExist";
    /** Session失效或不存在 */
    ResponseCode[ResponseCode["SessionNotExist"] = 3] = "SessionNotExist";
    /** Session未认证(未激活) */
    ResponseCode[ResponseCode["UnverifiedSession"] = 4] = "UnverifiedSession";
    /** 发送消息目标不存在(指定对象不存在) */
    ResponseCode[ResponseCode["TargetNotExist"] = 5] = "TargetNotExist";
    /** 指定文件不存在, 出现于发送本地图片 */
    ResponseCode[ResponseCode["FileNotExist"] = 6] = "FileNotExist";
    /** 无操作权限, 指Bot没有对应操作的限权 */
    ResponseCode[ResponseCode["NoPermission"] = 10] = "NoPermission";
    /** Bot被禁言, 指Bot当前无法向指定群发送消息 */
    ResponseCode[ResponseCode["BotIsMuted"] = 20] = "BotIsMuted";
    /** 消息过长 */
    ResponseCode[ResponseCode["MessageTooLong"] = 30] = "MessageTooLong";
    /** 错误的访问, 如参数错误等 */
    ResponseCode[ResponseCode["BadRequest"] = 400] = "BadRequest";
    /** mirai-api-http 内部错误 */
    ResponseCode[ResponseCode["InternalError"] = 500] = "InternalError";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
/** 支持的 mirai-api-http 版本号 */
exports.MIRAI_API_HTTP_VERSION = '2.5.0';
